import { isEmpty } from 'src/utils/isEmpty'

export const cleanObjectFromEmptyKeys = (obj: Record<string, Parameters<typeof isEmpty>['0']>) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => !isEmpty(v)))
}
